var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hm-info"},[_c('div',{staticClass:"hm-info__title"},[_c('InfoIcon'),_c('span',[_vm._v(_vm._s(_vm.rData.notes))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }